import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../elements/loader";
import Message from "../../../elements/message";
import { clearLogin, fetchCompanyMenu, fetchUserMenu } from "../../../../store/actions/login";
import { GetIcon } from "../../../../icons";

const withLayout = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();

    const user = useSelector((state) => state.login);

    const [showLoader, setShowLoader] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [messageState, setMessageState] = useState({
      type: 1,
      content: t("sessionExpired"),
      okay: t("startOver"),
      onClose: () => {
        dispatch(clearLogin());
        navigate("/");
      },
      code: 401
    });

    // =============== Helper Methods ========================
    const setLoaderBox = useCallback((status) => {
      console.log("status", status);
      setShowLoader(status);
    }, []);

    const setMessageBox = (messageContent) => {
      setMessageState(messageContent);
      setShowMessage(true);
    };

    const closeMessage = () => {
      setShowMessage(false);
    };

    // =======================================================
    // 3. Whenever selectedCompany changes → load correct menu
    // =======================================================
    useEffect(() => {
      if (!user?.data?.user?.authorisation || user?.data?.user?.authorisation !== "advisor") return;

      if (sessionStorage.getItem("selected-company") && sessionStorage.getItem("selected-company") !== "null" && sessionStorage.getItem("selected-company") !== "undefined") {
        console.log("123")
        setTimeout(() => {
          if(user?.data?.user?.authorisation==="advisor" && window.location.pathname.startsWith("/partner/") && !!user.data?.user?.company){
            dispatch(fetchUserMenu({})).then((data) => {
              navigate(data.menu[0]?.path || "/");
           });
          }
        }, 100);
      } else {
        if(user?.data?.user?.authorisation==="advisor" && !(window.location.pathname.startsWith("/partner/"))){
          dispatch(fetchUserMenu({})).then((data) => {
            navigate(data.menu[0]?.path || "/");
          });
        }
        setSelectedCompany(null);
        sessionStorage.setItem("selected-company", null)
      }
    }, [user?.data?.user?.authorisation]);

    // =======================================================
    // 4. Stop loader when token available
    // =======================================================
    useEffect(() => {
      if (user.data?.token) setShowLoader(false);
    }, [user.data?.token]);

    // =======================================================
    // 5. Render component
    // =======================================================
    if (!user.data?.token) {
      return (
        <Message
          meessage={messageState}
          closeMessage={closeMessage}
          setLoaderBox={setLoaderBox}
          showMessage={true}
        />
      );
    }

    return (
      <>
        <WrappedComponent
          {...props}
          user={user.data}
          setLoaderBox={setLoaderBox}
          setMessage={setMessageBox}
          selectedCompany={selectedCompany}
          setSelectedCompany={setSelectedCompany}
        />

        {/* <div style={{position: 'fixed', left: 0, right: 0, bottom: 0, backgroundColor: '#3FC4FD', zIndex: 1000}}> */}
          
        {/* </div> */}

        {showMessage && (
          <Message
            meessage={messageState}
            closeMessage={closeMessage}
            setLoaderBox={setLoaderBox}
            showMessage={showMessage}
          />
        )}

        {showLoader && <Loader />}
      </>
    );
  };
};

export default withLayout;
